/**
 * One string for whichever target a transmission carries.
 *
 * Clients key live speakers by target, and `undefined` is not a key: a space
 * radio and a channel radio must not collide in the same map just because
 * neither filled in the other's field.
 */
export function walkieTargetKey(target) {
    return target.spaceId ? `space:${target.spaceId}` : `channel:${target.channelId ?? ''}`;
}
/**
 * Who a radio card offers when nobody has chosen for it.
 *
 * Favourites first — a pinned conversation is the closest thing this product
 * has to "the person I always reach for" — then whoever spoke most recently.
 * Public channels are left out on purpose: they are the whole workspace, and
 * a card whose top suggestion might broadcast a held button to two hundred
 * people is a card nobody can press without checking first. Picking one by
 * hand still works; it is only what the card *proposes* that stays narrow.
 */
export function suggestedRadioTargets(channels, limit = 3) {
    return channels
        .filter((channel) => !channel.muted)
        .filter((channel) => channel.kind !== 'channel' || channel.isPrivate)
        .sort((a, b) => {
        if (Boolean(a.pinned) !== Boolean(b.pinned))
            return a.pinned ? -1 : 1;
        return (b.lastMessageAt ?? '').localeCompare(a.lastMessageAt ?? '');
    })
        .slice(0, limit);
}
/** Socket.IO rooms are namespaced with these prefixes. */
export const room = {
    org: (orgId) => `org:${orgId}`,
    user: (userId) => `user:${userId}`,
    space: (spaceId) => `space:${spaceId}`,
    zone: (spaceId, zoneId) => `space:${spaceId}:zone:${zoneId}`,
    channel: (channelId) => `channel:${channelId}`,
    project: (projectId) => `project:${projectId}`,
    board: (whiteboardId) => `board:${whiteboardId}`,
    sheet: (sheetId) => `sheet:${sheetId}`,
    doc: (docId) => `doc:${docId}`,
    slides: (deckId) => `slides:${deckId}`,
    file: (fileId) => `file:${fileId}`,
    meeting: (meetingId) => `meeting:${meetingId}`,
    call: (callId) => `call:${callId}`,
    game: (gameId) => `game:${gameId}`,
};
